export const CommonErrorMessages = {
  ConfirmPasswordRequired: 'Confirm password is required.',
  EmailNotValid: 'Email is not valid.',
  EmalRequired: 'Email is required.',
  FirstNameRequired: 'First name is required.',
  LastNameIsRequired: 'Last name is required.',
  NewPasswordRequired: 'New password is required.',
  OldPasswordRequired: 'Old password is required.',
  PasswordRequired: 'Password is required.',
  PasswordsDoNoMatch: 'New password and confirm password does not matched.',
  PasswordValidations:
    'Use at least 8 characters, it should combination of one upper case, lower case, special character, number, and without any space.',
  StatusErrorUpdate: 'Error while updating status',
  SelectCompany: 'Please select a company.',
  ErrorDownloadingFile: 'Error downloading the file',
  NofileFound: 'No files found in event target.',
  DownloadError: 'Download error:',
  UploadOneFile: 'You can only upload a one files.',
  ClaimLocked: 'The claim is locked. Please contact the administrator.',
  ActionNotPermitted: 'Action not permitted.',
  CompanyRequired: 'Select Company.',
  YearRequired: 'Select Claim Year.'
};

export const ResetPassErrorConstants = {
  ConfPassRequired: 'Confirm password is required.',
  NewPassInvalid:
    'New password must contain At least 1 uppercase letter, 1 lowercase letter, 1 special character, 1 number, and a minimum length of 8 characters',
  NewPassRequired: 'New password is required.',
  PassNotMatch: ' New password and confirm password does not matched.',
  NewPassNotMatch: ' New password and current password should not be same.',
  CurrentPassRequired: 'Current password is required.',
};

export const CommonFileUploadMessages = {
  FileSizeLimit:
    'File size should be 10 MB or less. Only allow Office Docs, PDF and Images.',
  FileNameRequired: 'Enter file name.',
  EditMode: 'Edit mode active.',
};

export const UserErrorMessages = {
  AddressRequired: 'Address is required.',
  CityRequired: 'City is required.',
  CountryRequired: 'Country is required.',
  EmailNotValid: 'Email is not valid.',
  EmalRequired: 'Email is required.',
  FirstNameRequired: 'First name is required.',
  LastNameIsRequired: 'Last name is required.',
  PhoneNoRequired: 'Phone number is required.',
  PhoneNumberNotValid: 'Phone number is not valid.',
  PostcodeRequired: 'Postal code is required.',
  PostalNotValid: 'Postal code is not valid.',
  RoleNameRequired: 'Role name is required.',
  StateRequired: 'State is required.',
  GenderRequired: 'Gender is required.',
  RoleHierarchyLevelRequired: 'Hierarchy level is required.',
  CompanyRequired: 'Company name is required.',
  ActiveUser: 'Are you sure you want to inactive this user?',
  InActiveUser: 'Are you sure you want to active this user?',
  ResendPasswordLink: 'Are you sure you want to send a reset password link to this user?',
  ResetPasswordLinkSentSuccessfully: 'Reset password link sent successfully.',
};

export const SoftwareErrorMessages = {
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  SoftwareRequired: 'Description of licence is required.',
  SoftwareVersion: 'Software version is required.',
  EmalRequired: 'Email is required.',
  SoftwareManufacturer: 'Software manufacturer is required.',
  PayCurrency: 'Pay Currency is required.',
  USDExchangeRate: 'USD exchange rate is required.',
  Cost: 'Cost is required.',
  LicenceKey: 'Licence key is required.',
  SoftwarePurchaseDate: 'Software purchase date is valid.',
  SoftwareExpieryDate: 'Software expiery date is required.',
  UseStartDate: 'Use start date is required.',
  UseEndDate: 'Use end date is required.',
  SoftwareNote: 'Software note is required.',
  NumberofLicence: 'Atleast 1 licence required',
  DeleteMessage: 'Are you sure you want to delete this software?',
  DownloadMessage: 'Software downloaded successfully.',
  Id:'Id is required.'
};

export const RoleErrorMessages = {
  RoleNameRequired: 'Role name is required.',
  RoleHierarchyLevelRequired: 'Role hierarchy level required',
};

export const UtilityErrorMessages = {
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  UtilityName: 'Utility name is required.',
  UtilityCost: 'Annual cost is required.',
  UniqueId: 'Id is required.',
  FinicialYearStartDate: 'Finicial year start date is required.',
  FinicialYearEndDate: 'Finicial year end date is required.',
  DeleteMessage: 'Are you sure you want to delete this utility?',
  DownloadSuccess: 'Water, fuel and power downloaded successfully.',
};

export const ConsumableErrorMessages = {
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  ItemDescription: 'Item description is required.',
  UniqueId: 'Id is required.',
  ConsumableCost: 'Cost is required.',
  FinicialYearStartDate: 'Finicial year start date is required.',
  FinicialYearEndDate: 'Finicial year end date is required.',
  DeleteMessage: 'Are you sure you want to delete this consumable item?',
  DownloadSuccess: 'Other consumable item downloaded successfully.',
};

export const PaymentsToClinicalTrialErrorMessages = {
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  ItemDescription: 'Item description is required.',
  ParticipantName: 'Participant name is required.',
  UniqueId: 'Id is required.',
  PaymentsToClinicalTrialCost: 'Cost is required.',
  DeleteMessage: 'Are you sure you want to delete this consumable item?',
  DownloadSuccess: 'Other consumable item downloaded successfully.',
};

export const DataLicenceErrorMessages = {
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  LicenceRequired: 'Data licence description is required.',
  LicenceVersion: 'Licence version is valid.',
  EmalRequired: 'Email is required.',
  PayCurrency: 'Pay currency is required.',
  USDExchangeRate: 'USD exchange rate is required.',
  Cost: 'Cost is required.',
  UniqueIdRequired: 'Id is required.',
  LicenceKey: 'Licence key is required.',
  DataLicencePurchaseDate: 'Data licence purchase date is valid.',
  DataLicenceExpieryDate: 'Data licence expiery date is required.',
  UseStartDate: 'Use start date is required.',
  UseEndDate: 'Use end date is required.',
  SoftwareNote: 'Software note is required.',
  NoOfLicence: 'No of licence is required.',
  NumberofLicence: 'Atleast 1 licence required',
  DeleteMessage: 'Are you sure you want to delete this data licence?',
  DownloadSuccess: 'Data licence downloaded successfully.',
};

export const CloudComputingErrorMessages = {
  CloudComputingCostsRequired: 'Description of cloud computing costs is required.',
  PayCurrency: 'Pay currency is required.',
  USDExchangeRate: 'USD exchange rate is required.',
  Cost: 'Cost is required.',
  UseStartDate: 'Use start date is required.',
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  UseEndDate: 'Use end date is required.',
  DeleteMessage: 'Are you sure you want to delete this cloud computing data?',
  DownloadSuccess: 'Cloud computing downloaded successfully.',
  Id:'Id is required.'
};

export const EPWConncetedCostErrorMessages = {
  SalaryRequired: 'Salary is required.',
  StartDate: 'Use start date is required.',
  EndDate: 'Use end date is required.',
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  Name: 'Contractor name is required.',
  Activities: 'Activity is required.',
  ExternalCost: 'External cost is required.',
  ConsumableCost: 'Consumable cost is required.',
  DataLicenceCost: 'Data licence cost is requird.',
  ComputingCost: 'Computing cost is required.',
  ClinicaltrialCost: 'Clinical trial cost required.',
  Cost: 'Cost is required.',
  Description: 'Description is required.',
  JobRole: 'Job role on the project is required.',
  StaffProvider: 'Staff provider is required.',
  PayESchemeReferenceToStaffProvider: 'Contractor PAYE reference is required.',
  PaymentsMadeToTheStaffProviderForUK:
    'Payments made to the staff provider for UK is required.',
  PaymentsMadeToTheStaffProviderForNonUK:
    'Payments made to the staff provider for non UK is required.',
  UnconnectedDownloadSuccess:
    'Externally Provided Workers - Unconnected  downloaded successfully.',
  DeleteMessage: 'Are you sure you want to delete this externally provided workers - unconnected ?',
  CountryRequired: 'Please select country in which EPW work was undertaken.',
  CommonCost: 'Either the cost for the UK or the cost for non-UK is required.',
   Id:'Id is required.'
};

export const ProjectErrorMessages = {
  projectName: 'Project name is required.',
  CompanyRequired: 'Company is required.',
  ProjectStartDate: 'R&D start date is required.',
  ProjectEndDate: 'R&D end date is required.',
};

export const EmployeeErrorMessages = {
  SalaryRequired: 'Salary is required.',
  Type: 'Type is required.',
  IsContractor: 'Is contractor is required.',
  CTC: 'CTC is required.',
  ProjectRequired: 'Project is required.',
  CompanyRequired: 'Company is required.',
  Name: 'Employee name is required.',
  IsEPW: 'IsEPW is required',
  Gross: 'Gross is required',
  EPS: 'EPS is required',
  NICS: 'NICS is required',
  EndDate: 'End date is required.',
  StartDate: 'Start date is required.',
  BasicPay: 'Basic pay is required.',
  EmployeeRole: 'Job role on the project is required.',
  CashAllowances: 'Cash allowances is required.',
  Cashbonuses: 'Cash bonuses is required.',
  NationalInsurances:
    'Employer contributions to national insurance is required.',
  Pension: 'Employer contributions to pension is required.',
  DeleteStaffingCost: 'Are you sure you want to delete this staffing cost?',
  DownloadMessage: 'Staffing Costs downloaded successfully.',
  Id:'Id is required.'
};

export const CompanyErrorMessages = {
  SalaryRequired: 'Salary is required.',
  CompanyName: 'Company name is required.',
  TaxUniqueRef: 'Tax unique reference is required.',
  VATNo: 'VAT no. is required.',
  SICCode: 'SIC code is required.',
  CompanyEmail: 'Company email is required.',
  Address: 'Address is required.',
  OfficeTelephoneNo: 'Office telephone no is required.',
  OfficeMobileNo: 'Office mobile no. is required.',
  PhoneNumberNotValid: 'Phone number is not valid.',
  EmailNotValid: 'Email is not valid.',
  ClaimStartDate: 'Accounting period start date is required.',
  ClaimEndDate: 'Accounting period end date is required.',
  CityRequired: 'City is required.',
  CountryRequired: ' Country is required.',
  PostcodeRequired: 'Postal code is required.',
  PostalNotValid: 'Postal code is not valid.',
  StateRequired: 'State is required.',
  PayeRefNumber: 'Employer PAYE reference number is required.',
  VatNumber: 'VAT number is required.',
  startEndDateValidation: ' StartDate must be earlier than end date.',
  StatusErrorUpdate: 'Error while updating status',
  LockedClaim: 'Are you sure you want to lock this claim?',
  UnLockedClaim: 'Are you sure you want to unlock this claim?',
  ActionNotPermitted: 'Action not permitted.',
  CompanyRequired: 'Company required.',
};

export const EPWConnectedPartyErrorMessages = {
  PersonNameRequired: 'Personnel name is required.',
  JobRole: 'Job role on the project is required.',
  BasicPay: 'Basic pay is required.',
  EmployeeRole: 'Job role on the project is required.',
  CashAllowance: 'Cash allowance is required.',
  CashBonus: 'Cash bonus is required.',
  ContributionToNationalInsurance:
    'Employer contributions to national insurance is required.',
  Pension: 'Employer contributions to pension is required.',
  NameOfConnectedParties: 'Name of staff provider is required.',
  PayeSchema: 'PAYE scheme reference of connected party is required.',
  DeleteMessage:
    'Are you sure you want to delete this Externally Provided Workers - Connected?',
  DownloadSuccessMessage:
    'Externally Provided Workers - Connected downloaded succesfully',
  CountryRequired: ' Country is required.',
   Id:'Id is required.'
};

export const ClientErrorMessages = {
  CompanyNameRequired: 'Company name is required',
  ClientName: 'Client name is required',
  EmalRequired: 'Email is required',
  EmailNotValid: 'Email is not valid.',
  ContactNumberRequired: 'Contact number is required',
  ContactNumberNotValid: 'Contact number is not valid',
  CityRequired: 'City is required.',
  CountryRequired: ' Country is required.',
  PostcodeRequired: 'Postal Code is required.',
  PostalNotValid: 'Postal code is not valid.',
  StateRequired: 'State is required.',
  ClaimType: 'Claim type is required',
  FirstName: 'First name is required',
  LastName: 'Last name is required',
};

export const AgentErrorMessages = {
  CompanyName: 'Company name is required',
  AgentName: 'Agent name is required',
  EmalRequired: 'Email is required',
  EmailNotValid: 'Email is not valid.',
  TelNumberRequired: 'Telephone number is required',
  TelNumberNotValid: 'Telephone number is not valid',
  CityRequired: 'City is required.',
  CountryRequired: ' Country is required.',
  PostcodeRequired: 'Postal Code is required.',
  PostalNotValid: 'Postal code is not valid.',
  StateRequired: 'State is required.',
  BusinessAddressRequired: 'Business Address is required',
  TypeOfAgent: 'Type of agent is required',
  BusinessName: 'Business name is required',
};

export const CompanyInfoFormErrorMessages = {
  BusinessName: 'Business name is Required.',
  TaxUniqueRef: 'Tax unique reference is required.',
  BusinessType: 'Business type/SIC code is required.',
  AgentFullName: 'Agent full name is required.',
  Email: 'Email is required.',
  EmailNotValid: 'Email is not valid.',
  AgentBusinessName: 'Agent business name is required.',
  TelNumberRequired: 'Telephone number is required.',
  TelNumberNotValid: 'Telephone number is not valid.',
  AgentBusinessAddress: 'Agent business address is required.',
  TypeOfAgent: 'Type of agent is required.',
  OtherAgentFullName: 'Other agent full name is required.',
  OtherAgentBusinessName: 'Other agent business name is required.',
  OtherAgentUkAddress: 'Other agent uk address is required.',
  SeniorOfficerFullName: 'Senior officer full name is required.',
  SeniorOfficerRole: 'Senior officer role is required.',
  AccountingStartDate: 'Accounting start date is required.',
  AccountingEndDate: 'Accounting end date is required.',
  CompanyTurnOver: 'Company turn over is required.',
  TotalStaffCost: 'Total staff cost is required.',
  PercentageMaxError: 'Value cannot be more than 100.',
  PercentagePatternError: 'Please enter a valid number.',
  PercentageRequiredError: 'This field is required.',
  TaxableProfitLoss: 'Value is required.',
  TotalPlExpenditure: 'Total P&L expenditure is required.',
  TotalExpenditureCTA:
    'Total expenditure claimed under s1308 CTA 2009 is required. ',
  TotalNonTaxExpenditure: 'Total non-tax deductible expenditure is required.',
  CorporateTaxRate: 'Applicable corporation tax rate is required.',
  PayableForAllStaffRequired: 'Payable for all staff is required.',
  TotalNIPayableRequired: 'Total NI payable for all staff is required.',
};

export const OtherMandatoryInfoFormErrorMessages = {
  TaxableProfitLoss: 'Taxable profit/loss before R&D is required.',
  TotalPlExpenditure: 'Total trading and operating expenditure.',
  TotalExpenditureCTA:
    'Total expenditure claimed under s1308 CTA 2009 is required.',
  TotalNonTaxExpenditure: 'Total non-tax deductible expenditure is required.',
  CorporateTaxRate: 'Applicable corporation tax rate is required.',
  PercentageMaxError: 'Value cannot be more than 100.',
  PercentagePatternError: 'Please enter a valid number.',
  PercentageRequiredError: 'Applicable corporation tax rate is required.',
};

export const PayCapFormErrorMessages = {
  amount1: 'Amount 1 is required.',
  amount1Positive: 'Amount 1 must be a positive number.',
  amount2: 'Amount 2 is required.',
  amount2Positive: 'Amount 2 must be a positive number.',
  amount3: 'Amount 3 is required.',
  amount3Positive: 'Amount 3 must be a positive number.',
  amount4: 'Amount 4 is required.',
  amount4Positive: 'Amount 4 must be a positive number.',
  amount5: 'Amount 5 is required.',
  amount5Positive: 'Amount 5 must be a positive number.',
  amount6: 'Amount 5 is required.',
  amount6Positive: 'Amount 5 must be a positive number.',
  IsExemptFromPAYECap: 'Exemption details is required .',
};

export const SubContractorUnconnectedErrorMessages = {
  Name: 'Subcontractor name is required.',
  Description:
    'Description of activities is required.',
  Cost: 'Cost is required.',
  DeleteMessage:
    'Are you sure you want to delete this Contracted Out R&D - Unconnected ?',
  DownloadSuccess: 'Contracted Out R&D - Unconnected downloaded successfully.',
  CostUk: 'Cost UK is required',
  CostNonUks: 'Cost for non UK is required',
  CommonCost: 'Either the cost for the UK or the cost for non-UK is required.',
  Id:'Id is required.'
};

export const SubContractorConnectedPaeriesErrorMessages = {
  Name: 'Subcontractor connected party name is required.',
  Description: 'Description of activities undertaken is required.',
  ExternallyProvider: 'Externally provided workers is required.',
  Cost: 'Staffing costs is required.',
  ConsumableItem: 'Consumable items is required.',
  RowCost: 'Software, data licences, cloud computing is required.',
  Payments: 'Payments to subjects of clinical trials is required.',
  Total: 'Total (£).',
  TotalForNonUk: 'Cost for non UK is required',
  DeleteMessage:
    'Are you sure you want to delete this Contracted Out R&D - Connected?',
  DownloadSuccessMessage:
    'Contracted Out R&D - Connected parties downloaded successfully.',
  CountryRequired: ' Country is required.',
  CountrySelect: 'Please select a country first.',
  CommonCost: 'Either the cost for the UK or the cost for non-UK is required.',
  Id:'Id is required.'
};

export const LoginDevicesErrorMessages = {
  DeleteLoginDevice: 'Are you sure you want to logout this device?',
  OtpReqired: 'OTP is required',
};

export const NoteErrorMessages ={
  companyRequired: 'Company is required',
  claimYearRequired: 'Claim year is required',
  subjectRequired: 'Subject is required',
  descriptionRequired: 'Description is required',
  statusRequired: 'Please select a status',
}

export const AdditonalInformationFormMessages ={
  downloadSucess : "Additional information form downloaded successfully.",
  downloadProjectSucess : "Project Additional information form downloaded successfully."
}

export const RNDClaimApproachFormMessages ={
  downloadSucess : "R&D claim approach report downloaded successfully."
}
